import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Dialog, DialogDescription, DialogOverlay, DialogPortal } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useMountEffect } from '@react-hookz/web';
import { useCallback, useRef } from 'react';
import { Backdrop, CloseButton, Content, Title } from '../../primitives/ContentLayer/components/index.js';
export const ContentLayer = /*#__PURE__*/_styled(({
  open = false,
  onClose,
  closeButtonLabel,
  children,
  title,
  visuallyHideTitle,
  description,
  hideTitle = false,
  small = false,
  ...restProps
}) => {
  const portalRoot = useRef(null);
  useMountEffect(() => {
    portalRoot.current = document.getElementById('portal-root');
  });
  const handleOpenChange = useCallback(open => {
    if (!open && onClose) {
      onClose();
    }
  }, [onClose]);
  const shouldRenderDescription = Boolean(description);
  const describedBy = {};
  if (!shouldRenderDescription) {
    describedBy['aria-describedby'] = undefined;
  }
  return _jsx(Dialog, {
    open: open,
    onOpenChange: handleOpenChange,
    modal: true,
    children: _jsx(DialogPortal, {
      container: portalRoot.current,
      children: _jsxs(DialogOverlay, {
        children: [_jsx(Backdrop, {}), _jsxs(Content, {
          ...describedBy,
          small: small,
          ...restProps,
          children: [!hideTitle && _jsx(Title, {
            visuallyHidden: visuallyHideTitle,
            children: visuallyHideTitle ? _jsx(VisuallyHidden, {
              children: title
            }) : title
          }), _jsx(VisuallyHidden, {
            asChild: true,
            children: _jsx(DialogDescription, {
              children: description
            })
          }), _jsx(CloseButton, {
            label: closeButtonLabel,
            small: small
          }), children]
        })]
      })
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e19ikhln0"
} : {
  target: "e19ikhln0",
  label: "ContentLayer"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");